import React from 'react';
import styles from './ItemDetailAcCtN.scss';
import classNames from 'classnames/bind';

import Adsense300250 from 'components/adsense/Adsense300250';

// import {NumericFormat} from 'react-number-format';

// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { 
//   faX, prefix
// } from '@fortawesome/free-solid-svg-icons';

const cx = classNames.bind(styles);

const powerUpList = [
  {name: '노강', titleName:'', titleClName: '[CL]', option: {
    accDmg: '2', accCri: '10', accCon:'70', accDfs: '200', accDot: '1',
    leftRingDmg: '1', leftRingCon: '100', leftRingDfs: '150',
    beltDmg: '1', beltCon: '65', beltDfs: '180', beltStm: '50', 
    beltRun: '50', beltCri: '10', beltMag: '50', beltWei: '100', 
    beltDot: '10', beltPot: '15'
  }},
  {name: '1강', titleName:'+1', titleClName: '[CL]+1', option: {
    accDmg: '2', accCri: '10', accCon:'99', accDfs: '232', accDot: '2',
    leftRingDmg: '3', leftRingCon: '210', leftRingDfs: '268',
    beltDmg: '1', beltCon: '86', beltDfs: '200', beltStm: '61', 
    beltRun: '51', beltCri: '11', beltMag: '55', beltWei: '200', 
    beltDot: '12', beltPot: '17'
  }},
  {name: '2강', titleName:'+2', titleClName: '[CL]+2', option: {
    accDmg: '3', accCri: '10', accCon:'129', accDfs: '265', accDot: '3',
    leftRingDmg: '6', leftRingCon: '320', leftRingDfs: '327',
    beltDmg: '1', beltCon: '108', beltDfs: '220', beltStm: '72', 
    beltRun: '52', beltCri: '12', beltMag: '61', beltWei: '300', 
    beltDot: '14', beltPot: '19'
  }},
  {name: '3강', titleName:'+3', titleClName: '[CL]+3', option: {
    accDmg: '4', accCri: '10', accCon:'159', accDfs: '298', accDot: '4',
    leftRingDmg: '8', leftRingCon: '430', leftRingDfs: '386',
    beltDmg: '1', beltCon: '130', beltDfs: '240', beltStm: '83', 
    beltRun: '53', beltCri: '13', beltMag: '66', beltWei: '400', 
    beltDot: '16', beltPot: '21'
  }},
  {name: '4강', titleName:'+4', titleClName: '[CL]+4', option: {
    accDmg: '5', accCri: '10', accCon:'188', accDfs: '386', accDot: '5',
    leftRingDmg: '11', leftRingCon: '540', leftRingDfs: '386',
    beltDmg: '1', beltCon: '151', beltDfs: '260', beltStm: '94', 
    beltRun: '54', beltCri: '14', beltMag: '72', beltWei: '500', 
    beltDot: '18', beltPot: '23'
  }},
  {name: '5강', titleName:'+5', titleClName: '[CL]+5', option: {
    accDmg: '5', accCri: '10', accCon:'218', accDfs: '363', accDot: '6',
    leftRingDmg: '13', leftRingCon: '650', leftRingDfs: '445',
    beltDmg: '2', beltCon: '173', beltDfs: '280', beltStm: '105', 
    beltRun: '55', beltCri: '15', beltMag: '77', beltWei: '600', 
    beltDot: '21', beltPot: '26'
  }},
  {name: '6강', titleName:'+6', titleClName: '[CL]+6', option: {
    accDmg: '6', accCri: '10', accCon:'248', accDfs: '396', accDot: '7',
    leftRingDmg: '16', leftRingCon: '760', leftRingDfs: '504',
    beltDmg: '2', beltCon: '195', beltDfs: '300', beltStm: '116', 
    beltRun: '56', beltCri: '16', beltMag: '83', beltWei: '700', 
    beltDot: '23', beltPot: '28'
  }},
  {name: '7강', titleName:'+7', titleClName: '[CL]+7', option: {
    accDmg: '7', accCri: '10', accCon:'278', accDfs: '429', accDot: '8',
    leftRingDmg: '18', leftRingCon: '870', leftRingDfs: '563',
    beltDmg: '2', beltCon: '216', beltDfs: '320', beltStm: '127', 
    beltRun: '57', beltCri: '17', beltMag: '88', beltWei: '800', 
    beltDot: '25', beltPot: '30'
  }},
  {name: '8강', titleName:'+8', titleClName: '[CL]+8', option: {
    accDmg: '8', accCri: '10', accCon:'307', accDfs: '462', accDot: '9',
    leftRingDmg: '21', leftRingCon: '980', leftRingDfs: '622',
    beltDmg: '2', beltCon: '238', beltDfs: '340', beltStm: '138', 
    beltRun: '58', beltCri: '18', beltMag: '94', beltWei: '900', 
    beltDot: '27', beltPot: '32'
  }},
  {name: '9강', titleName:'+9', titleClName: '[CL]+9', option: {
    accDmg: '9', accCri: '10', accCon:'337', accDfs: '494', accDot: '10',
    leftRingDmg: '24', leftRingCon: '1090', leftRingDfs: '681',
    beltDmg: '3', beltCon: '260', beltDfs: '360', beltStm: '150', 
    beltRun: '60', beltCri: '20', beltMag: '100', beltWei: '1000', 
    beltDot: '30', beltPot: '35'
  }}
];

const ItemDetailAcCt = ({popupClose, currSelAcCt, ctrlAcCtUp, setPowerup}) => {
  const {currItem, currItemOption} = currSelAcCt;
  const {optionView, powerUp} = currItemOption;
  const {
    ITEM_NM, IMG_SRC, ITEM_DTL_DV, DMG, CON, CRI, DFS, DOT, CLYN,
    STM, RUN, MAG, WEI, POT
  } = currItem;

  const powerBtns = powerUpList.map((ele, cnt) => {
    const {name} = ele;
  
    return (
      <>
        <input type='radio' id={`powerUp${cnt}`} name='powerUp' alt={name} value={name} key={cnt} />
        <label className={cx(`up${cnt}`)} htmlFor={`powerUp${cnt}`}
        onClick={() => setPowerup(cnt)}>{name}</label>
      </>
    )
  });

  return (
    <div className={cx('item-card')}>
      <h2>{ITEM_NM + powerUpList[powerUp].titleName}</h2>
      <div className={cx('item-content')}>
        <div className={cx('item-left')}>
          <div className={cx('item-img')}>
            <img src={IMG_SRC} alt={ITEM_NM} />
          </div>

          <div className={cx('item-btn-group')}>
            {CLYN === 'Y' ?
            <button className={cx('item-btn')} onClick={ctrlAcCtUp} /*onMouseOver={ctrlArmmorUp}*/ value='강화'>강화</button>
            : <></>}

            <div className={cx('combo-box')} style={optionView === '' ? {display:'none'} : {display:'grid'}}>
              {powerBtns}
            </div>
          </div>

          <div className={cx('item-info')}>
            <span className={cx('item-subtitle1')}>착용 시 케릭터 능력치 상승</span>
            <span className={cx('item-subtitle2')}>공격력 & 방어력 & 회피 상승</span>
            <span className={cx('item-line')}></span>
            <span className={cx('item-hands')}>종류:{ITEM_DTL_DV}</span>
            <span className={cx('item-weight')}>무게 :1/1</span>
            {DFS > 0 ?
            <span className={cx('item-dfs')}>방어력:{
              ITEM_DTL_DV === '왼손반지' ? powerUpList[powerUp].option.leftRingDfs :
              ITEM_DTL_DV === '벨트' ? powerUpList[powerUp].option.beltDfs :
              powerUpList[powerUp].option.accDfs
            }</span>
            : <></>}
            {DOT > 0 ?
            <span className={cx('item-grade')}>회피도:{
              ITEM_DTL_DV === '벨트' ? powerUpList[powerUp].option.beltDot :
              powerUpList[powerUp].option.accDot
            }</span>
            : <></>}
            <span className={cx('item-line')}></span>
            {DMG > 0 ?
            <span className={cx('item-dmg')}>공격력:{
              ITEM_DTL_DV === '왼손반지' ? powerUpList[powerUp].option.leftRingDmg :
              ITEM_DTL_DV === '벨트' ? powerUpList[powerUp].option.beltDmg :
              powerUpList[powerUp].option.accDmg
            }</span>
            : <></>}
            {CON > 0 ?
            <span className={cx('item-con')}>체력:{
              ITEM_DTL_DV === '왼손반지' ? powerUpList[powerUp].option.leftRingCon :
              ITEM_DTL_DV === '벨트' ? powerUpList[powerUp].option.beltCon :
              powerUpList[powerUp].option.accCon
            }</span>
            : <></>}
            {CRI > 0 ?
            <span className={cx('item-cri')}>치명율:{
              ITEM_DTL_DV === '왼손반지' ? powerUpList[powerUp].option.leftRingCri :
              ITEM_DTL_DV === '벨트' ? powerUpList[powerUp].option.beltCri :
              powerUpList[powerUp].option.accCri
            }</span>
            : <></>}

            {STM > 0 ?
            <span className={cx('item-stm')}>지구력:{
              ITEM_DTL_DV === '벨트' ? powerUpList[powerUp].option.beltStm :
              STM
            }</span>
            : <></>}
            {RUN > 0 ?
            <span className={cx('item-run')}>속도:{
              ITEM_DTL_DV === '벨트' ? powerUpList[powerUp].option.beltRun :
              RUN
            }</span>
            : <></>}
            {MAG > 0 ?
            <span className={cx('item-mag')}>행동력:{
              ITEM_DTL_DV === '벨트' ? powerUpList[powerUp].option.beltMag :
              MAG
            }</span>
            : <></>}
            {WEI > 0 ?
            <span className={cx('item-weight')}>무게감소:-{
              ITEM_DTL_DV === '벨트' ? powerUpList[powerUp].option.beltWei :
              WEI
            }</span>
            : <></>}
            {POT > 0 ?
            <span className={cx('item-pot')}>탄착율:{
              ITEM_DTL_DV === '벨트' ? powerUpList[powerUp].option.beltPot :
              POT
            }</span>
            : <></>}

            <span className={cx('item-line')}></span>
            <span className={cx('item-count')}>창고포함 보유갯수:1개</span>
          </div>
        </div>

        <div class="ad-box">
          <Adsense300250 />
        </div>
      </div>
    </div>
  );
}

export default ItemDetailAcCt;